import {useNavigate} from "react-router-dom";
import ReactPlayer from "react-player";
import {AppPage} from "common/Layout";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {
  getAdditionalMaterialsUrl,
  getAnnotationUrl, getHomeUrl,
  getInteractiveUrl,
  getLiteratureUrl, getMethodologicalModuleUrl, getPracticalModuleUrl,
  getTargetUrl,
  getTestUrl,
  getTheoryUrl, getVideoUrl
} from "services/navigation";
import type {
  VideoPage as VideoPageType,
  InteractivePage as InteractivePageType,
  Page,
  MethodologicalModulePage as MethodologicalModulePageType,
  PracticalModulePage as PracticalModulePageType
, TheoryPage as TheoryPageType} from "../../config/types";
import {PageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import styles from "./styles.module.scss";

export const VideoPage = () => {
  const navigate = useNavigate();
  const videoPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.VIDEO) as VideoPageType;

  const getUrl = (page: Page) => {
    switch (page.type) {
      case PageType.ANNOTATION:
        return getAnnotationUrl();
      case PageType.INTERACTIVE:
        return getInteractiveUrl({id: (page as InteractivePageType).id});
      case PageType.LITERATURE:
        return getLiteratureUrl();
      case PageType.TARGET:
        return getTargetUrl();
      case PageType.TEST:
        return getTestUrl();
      case PageType.THEORY:
        return getTheoryUrl({id: (page as TheoryPageType).id});
      case PageType.VIDEO:
        return getVideoUrl();
      case PageType.METHODOLOGICAL_MODULE:
        return getMethodologicalModuleUrl({id: (page as MethodologicalModulePageType).id});
      case PageType.PRACTICAL_MODULE:
        return getPracticalModuleUrl({id: (page as PracticalModulePageType).id});
      case PageType.ADDITIONAL_MATERIALS:
        return getAdditionalMaterialsUrl();
      default:
        return getHomeUrl();
    }
  };

  const goToNextPage = () => {
    const nextPage = GLOBAL_CONFIG.pages.find(page => page.order === videoPage.order + 1);

    if (nextPage) {
      const url = getUrl(nextPage);
      navigate(url);
    }
  };

  if (!videoPage) {
    return null;
  }

  return (
    <AppPage contentClassName={styles.content} pageTitle="Видео" documentTitle="Видео">
      <AppFlex unit="0" className={styles.container} alignItems="center" justifyContent="flex-start">
        <AppText size={24}>Видео</AppText>
        <ReactPlayer config={{file: {
            attributes: {
              disablePictureInPicture: true,
              controlsList: "nodownload noremoteplayback noplaybackrate"
            }
          }}} className={styles.video} controls url={videoPage.videoPath}/>
      </AppFlex>
      <AppButton className={styles.nextPageBtn} onClick={goToNextPage}>{videoPage.nextBtnName}</AppButton>
    </AppPage>
  );
};

